export type Severity = 'low' | 'medium' | 'high';

interface SeverityBadgeProps {
  severity: Severity;
  showLabel?: boolean;
  severityLabels?: {
    high: string;
    medium: string;
    low: string;
  };
}

const severityStyles = {
  high: 'bg-meeting-600 text-white',
  medium: 'bg-meeting-400 text-white',
  low: 'bg-meeting-100 text-meeting-600',
};

const defaultLabels = {
  high: 'High Severity',
  medium: 'Medium Severity',
  low: 'Low Severity',
};

export const SeverityBadge = ({
  severity,
  showLabel = true,
  severityLabels,
}: SeverityBadgeProps) => {
  const labels = severityLabels || defaultLabels;
  const label = showLabel ? labels[severity] : severity;

  return (
    <span className={`text-xs px-2 py-1 rounded-full font-medium ${severityStyles[severity]}`}>
      {label}
    </span>
  );
};

export const getSeverityCardStyles = (severity: Severity): string => {
  const styles = {
    high: 'bg-gray-50 border-gray-200',
    medium: 'bg-gray-50 border-gray-200',
    low: 'bg-gray-50 border-gray-200',
  };
  return styles[severity];
};

export const getSeverityLinkStyles = (severity: Severity): string => {
  const styles = {
    high: 'bg-meeting-200 border-meeting-600',
    medium: 'bg-meeting-50 border-meeting-300',
    low: 'bg-meeting-50 border-meeting-100',
  };
  return styles[severity];
};

export const calculateHighestSeverity = <T extends { contradictionSeverity?: Severity | null }>(
  links: T[],
): Severity => {
  const severityOrder = { high: 3, medium: 2, low: 1 };
  const safeLinks = Array.isArray(links) ? links : [];
  return safeLinks.reduce((max: Severity, link: T) => {
    const linkSeverity = link.contradictionSeverity || 'low';
    return severityOrder[linkSeverity] > severityOrder[max] ? linkSeverity : max;
  }, 'low' as Severity);
};
